import { axiosInstance } from '~/services';

import type { TypeErrorResponseData } from '~/types/common.types';
import type { TypePostStocksSkuParams, TypePostStocksSkuResponse } from '~/types/stock.types';

const usePostStocksSku = () => {
  const endPoint = '/api-inventory/v1/third-parties/stocks/sku';

  const postStocksSku = async (params: TypePostStocksSkuParams) => {
    return axiosInstance
      .post<TypePostStocksSkuResponse>(endPoint, {
        ...params,
      })
      .then(({ data: { data, pagination } }) => {
        return { data, pagination };
      })
      .catch((error: TypeErrorResponseData['error']) => {
        throw error;
      });
  };

  return { postStocksSku };
};

export default usePostStocksSku;
